import { Checkbox, FormControl, FormLabel, Flex } from "@chakra-ui/react";

const CheckboxFormControl = ({ label, name, onChange, isChecked, ...props }) => {
    return (
        <FormControl display="flex" alignItems="center" width="100%" {...props}>
            <Flex justifyContent="space-between" width="100%">
                <FormLabel mb="0" flexShrink={0} fontWeight="normal">{label}</FormLabel>
                <Checkbox
                    name={name}
                    onChange={onChange}
                    isChecked={isChecked}
                />
            </Flex>
        </FormControl>
    );
};

export default CheckboxFormControl;
